import PIE_BOMB_IMAGE_URL from './pie.png';
export { PIE_BOMB_IMAGE_URL };
export const PIE_BOMB_SPRITESHEET_DATA = {
    frames: {
        'pie0001.png': {
            frame: { x: 1, y: 1, w: 202, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 3, w: 202, h: 107 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0002.png': {
            frame: { x: 1, y: 220, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 1, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0003.png': {
            frame: { x: 411, y: 221, w: 202, h: 111 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 8, y: 0, w: 202, h: 111 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0004.png': {
            frame: { x: 411, y: 334, w: 201, h: 111 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 9, y: 0, w: 201, h: 111 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0005.png': {
            frame: { x: 411, y: 447, w: 202, h: 111 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 8, y: 0, w: 202, h: 111 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0006.png': {
            frame: { x: 206, y: 221, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 6, y: 1, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0007.png': {
            frame: { x: 1, y: 110, w: 203, h: 108 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 3, y: 3, w: 203, h: 108 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0008.png': {
            frame: { x: 206, y: 110, w: 201, h: 109 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 1, w: 201, h: 109 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0009.png': {
            frame: { x: 205, y: 1, w: 202, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 3, w: 202, h: 107 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0010.png': {
            frame: { x: 409, y: 110, w: 203, h: 109 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 1, w: 203, h: 109 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0011.png': {
            frame: { x: 1, y: 332, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0012.png': {
            frame: { x: 206, y: 333, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0013.png': {
            frame: { x: 1, y: 444, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0014.png': {
            frame: { x: 206, y: 445, w: 203, h: 110 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 1, w: 203, h: 110 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        },
        'pie0015.png': {
            frame: { x: 409, y: 1, w: 202, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 3, w: 202, h: 107 },
            sourceSize: { w: 210, h: 111 },
            anchor: { x: 0.488095, y: 0.567568 }
        }
    },
    animations: {
        animation: [
            'pie0001.png',
            'pie0002.png',
            'pie0003.png',
            'pie0004.png',
            'pie0005.png',
            'pie0006.png',
            'pie0007.png',
            'pie0008.png',
            'pie0009.png',
            'pie0010.png',
            'pie0011.png',
            'pie0012.png',
            'pie0013.png',
            'pie0014.png',
            'pie0015.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: PIE_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 614, h: 614 },
        scale: '0.5',
        smartupdate: '$TexturePacker:SmartUpdate:8cf234bffe9d5fd6188102b5d493a4d3:604a82ad31fbd9b42cdebe413e1979c4:1e9337f39878714d1dc0ea38d89d6b16$'
    }
};
